module.exports = require('./' + process.env.CONFIG_FILE);
